export const ROUTES = {
  STATE_OF_RESIDENCE: 'state-of-residence',
  QUOTE: 'quote',
  LOAD_QUOTE: 'load',
  //trip creation flow
  TRIP_DESTINATIONS: 'trip-destinations',
  TRIP_DATES: 'trip-dates',
  TRIP_TRAVELLERS: 'trip-travellers',
  TRIP_COST: 'trip-cost',
  TRIP_DEPOSIT_DATE: 'trip-deposit-date',
  //boost flow
  MY_QUOTE: 'my-quote', // 1-page quote
  BOOST_DETAILS: 'boost-details',
  //payment flow
  CHECKOUT: 'checkout',
  CONFIRMATION: 'confirmation',
} as const;

export type ROUTES = (typeof ROUTES)[keyof typeof ROUTES];
